import { render, staticRenderFns } from "./ApplicationsListWrapper.vue?vue&type=template&id=5f0a816b&scoped=true&"
import script from "./ApplicationsListWrapper.vue?vue&type=script&lang=js&"
export * from "./ApplicationsListWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0a816b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0a816b')) {
      api.createRecord('5f0a816b', component.options)
    } else {
      api.reload('5f0a816b', component.options)
    }
    module.hot.accept("./ApplicationsListWrapper.vue?vue&type=template&id=5f0a816b&scoped=true&", function () {
      api.rerender('5f0a816b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploads/components/History/ApplicationsListWrapper.vue"
export default component.exports